<div class="cv-overview-data">
	<div class="cv-overview-data__property-information">
		<div class="cv-overview-data__title">
			<span>{{dataModel[0].title}}</span>
		</div>
		<div class="cv-overview-data__info p-0">
			<table class="table table-borderless mb-0">
				<tbody>
					<tr>
						<td class="w-25 p-0">
							<div class="photo-container">
								<cv-gallery *ngIf="photosCollection && photosCollection.length > 0" [album]="photosCollection" [options]="galleryOptions"></cv-gallery>

								<div class="container-no-files" *ngIf="photosCollection.length <= 0">
									<img src="assets/img/placeholder/No-file-asset.png">
									<p>No files available</p>
								</div>
							</div>
						</td>
						<td class="w-75">
							<div
								*ngFor="let item of dataModel[0].items"
								#overviewFailed
								(click)="onFieldSelected(item.path)"
								class="{{item.class}} {{ target.includes(item.path) ? csshighlight : ''}}"
								[attr.path]="item.path"
								[ngClass]="{'canSelectField':onFieldHasRule(item.path)}"
							>
								{{item.label ? item.label: getDocValue(item.path) }}
								<span class="cv-overview-data__info__date__effective" *ngIf="item.label">
									{{ getDocValue(item.path) }}
								</span>
								<ng-template
									*ngTemplateOutlet="historicalTpl;  context:{$implicit:item}"
								></ng-template>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="cv-overview-data__appraiser-information">
		<div class="cv-overview-data__title">
			<span>{{dataModel[1].title}}</span>
		</div>
		<div class="cv-overview-data__info p-0">
			<table class="table table-striped mb-0">
				<tbody>
					<tr
						*ngFor="let item of dataModel[1].items"
						(click)="onFieldSelected(item.path)"
						#overviewFailed
						[attr.path]="item.path"
						class="{{ target.includes(item.path) ? csshighlight : ''}}"
						[ngClass]="{'canSelectField':onFieldHasRule(item.path)}"
					>
						<td class="cv-overview-data__info__appraiser">{{item.label}}</td>
						<td class="cv-overview-data__info__appraiser__value">
							{{getDocValue(item.path)}}
							<ul class="mb-0 list-unstyled" *ngIf="item.multipleValues">
								<li>
									{{ getDocIterable(item.multipleValuesSource) }}
								</li>
							</ul>
							<ng-template
								*ngTemplateOutlet="historicalTpl; context:{$implicit:item}"
							></ng-template>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<ng-template #historicalTpl let-item>
	<div class="{{item.historicalClass}}">
		<button
			#changesEl
			*ngIf="historicalOpt.hasH"
			class="btn btn-sm cv-btn-revised_fields"
			(click)="onHistoricalVal(item.path,changesEl)"
		>
			<i class="fas fa-clipboard-list"></i>
			<span>{{ historicalOpt.length}}</span>
		</button>
	</div>
</ng-template>
